import { roadA1 } from "../../utils/ROADS/roadA1";
import RoadMapGeneric from "../../components/Roadmaps/RoadMapGeneric";

const RoadMapA1 = (props) => <RoadMapGeneric {...props} roadData={roadA1} />;

export default RoadMapA1;